import React, { useEffect, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Badge from '../../../UniformComponents/Badge'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

import './groupedVerbatimWidget.scss'
import LinkButton from '../../../UniformComponents/LinkButton'
import Input from '../../form/Input'
import { stripHtml } from '../../../utils/helpers'

const GroupedVerbatimWidget = observer(({ chartData }) => {
    const [questionCount, allQTotalResponses] = useMemo(() => {
        const count = chartData.reduce((total, q) => total + q.responses?.reduce((t, r) => r.count + t, 0), 0)
        return [chartData.length, count]
    }, [chartData])

    const renderRow = (row) => (
        <>
            <div className="row">
                <div className="icons">
                    <i className="fa-solid fa-quote-left" />
                    <div className="count">{row.count}</div>
                </div>
                <div className="rowLabel">{stripHtml(row.label)}</div>
            </div>
            <hr className="rowHr" />
        </>
    )

    const renderGroup = (group) => {
        const totalResponses = group.responses.reduce((t, re) => t + re.count, 0)
        return (
            <div className="group">
                <div className="groupTitle">
                    <div className="title">{stripHtml(group.shortName)}</div>
                    <div className="numResponses">{totalResponses}</div>
                </div>
                {group.responses.map((r) => renderRow(r))}
            </div>
        )
    }
    return (
        <div className="groupedVerbatimWidget">
            <div className="title">
                Event Feedback
            </div>
            <hr />
            <div className="subTitle">
                {allQTotalResponses}
                {' '}
                responses across
                {' '}
                {questionCount}
                {' '}
                questions
            </div>
            <div className="verbatimResponses">
                {chartData.map((g) => renderGroup(g))}
            </div>
        </div>
    )
})

export default GroupedVerbatimWidget
